<div class="space-y-6">
  <div class="flex items-center justify-between">
    <h1 class="text-2xl font-bold text-gray-900">Medical Records</h1>
    <app-button variant="primary" (clicked)="openAddModal()">
      <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      Add Record
    </app-button>
  </div>

  <div class="card overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Patient</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Visit Type</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Chief Complaint</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Diagnosis</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          @if (records().length === 0) {
            <tr>
              <td colspan="6" class="px-6 py-8 text-center text-gray-500">No medical records found</td>
            </tr>
          } @else {
            @for (record of records(); track record.id) {
              <tr class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ record.patientName }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ record.date | date:'short' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ record.visitType }}</td>
                <td class="px-6 py-4 text-sm text-gray-900">{{ record.chiefComplaint }}</td>
                <td class="px-6 py-4 text-sm text-gray-900">
                  {{ record.diagnosis.join(', ') || 'N/A' }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button (click)="openEditModal(record)" class="text-primary-600 hover:text-primary-900 mr-4">View</button>
                  <app-button variant="danger" (clicked)="deleteRecord(record.id)">Delete</app-button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  @if (showModal()) {
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="closeModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="p-6 border-b">
          <h2 class="text-xl font-semibold text-gray-900">
            {{ editingRecord() ? 'Edit Medical Record' : 'Add Medical Record' }}
          </h2>
        </div>
        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Patient</label>
            <select [(ngModel)]="recordForm().patientId" (change)="onPatientSelect($any($event.target).value)" class="input-field">
              <option value="">Select Patient</option>
              @for (patient of patients(); track patient.id) {
                <option [value]="patient.id">{{ patient.firstName }} {{ patient.lastName }}</option>
              }
            </select>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Date</label>
              <input type="date" [value]="recordForm().date ? (recordForm().date | date:'yyyy-MM-dd') : ''" 
                     (input)="onDateChange(($any($event.target)).value)" class="input-field" />
            </div>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Visit Type</label>
              <select [(ngModel)]="recordForm().visitType" class="input-field">
                <option value="Consultation">Consultation</option>
                <option value="Follow-up">Follow-up</option>
                <option value="Emergency">Emergency</option>
                <option value="Routine Check">Routine Check</option>
              </select>
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Chief Complaint</label>
            <textarea [(ngModel)]="recordForm().chiefComplaint" class="input-field" rows="2"></textarea>
          </div>
          <div>
            <app-input
              label="Diagnosis (comma-separated)"
              type="text" 
              [ngModel]="recordForm().diagnosis?.join(', ')" 
              (ngModelChange)="onDiagnosisChange($event)">
            </app-input>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Notes</label>
            <textarea [(ngModel)]="recordForm().notes" class="input-field" rows="4"></textarea>
          </div>
        </div>
        <div class="p-6 border-t flex justify-end space-x-3">
          <app-button variant="secondary" (clicked)="closeModal()">Cancel</app-button>
          <app-button variant="primary" (clicked)="saveRecord()">Save</app-button>
        </div>
      </div>
    </div>
  }
</div>

